import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { makePrioStyles } from '../../../../../../theme/utils';
import Flex from '../../../../../../components/Flex';
import { ProjectId } from '../../../../../../models/Types';
import { useSelector } from 'react-redux';
import {
  getProject,
  RootReducerState,
} from '../../../../../../apps/main/rootReducer';
import { Project } from '../../../../../../models/Project';
import { ProjectExtensionType } from '../../../../../../models/ProjectExtension';
import SvgIcon from '../../../../../../components/SvgIcon';
import { getSvgIconPathByType } from '../../../../../../util/icon';
import { Empty } from '@prio365/prio365-react-library';

const useStyles = makePrioStyles((theme) => ({
  root: {
    height: '100%',
    width: '100%',
  },
  content: {
    flex: 1,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iframeWrapper: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  iframeView: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: theme.spacing.regular,
  },
  icon: {
    marginBottom: theme.spacing.regular,
  },
}));

const getProjectExtensionMe = (
  project: Project,
  type: ProjectExtensionType
) => {
  if (!project) {
    return undefined;
  }
  return project.projectExtensionMeDtos?.find(
    (ext) => ext.projectExtensionType === type
  );
};

interface AmberSearchPageProps {
  projectId: ProjectId;
  className?: string;
}

const AmberSearchPage: React.FC<AmberSearchPageProps> = ({
  projectId,
  className,
}) => {
  //#region ------------------------------ Defaults
  const classes = useStyles();
  const { t } = useTranslation();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const project = useSelector<RootReducerState, Project>((state) =>
    getProject(state, projectId)
  );

  const amberSearchProjectExtension = useMemo(() => {
    return getProjectExtensionMe(project, 'amberSearch');
  }, [project]);

  const amberSearchUrl = amberSearchProjectExtension?.value;
  //#endregion

  return (
    <Flex.Column className={classNames(classes.root, className)}>
      <div className={classes.content}>
        {amberSearchUrl ? (
          <div className={classes.iframeWrapper}>
            <iframe
              className={classes.iframeView}
              src={amberSearchUrl}
              title="Ambersearch"
            />
          </div>
        ) : (
          <div className={classes.emptyState}>
            <SvgIcon
              width={100}
              height={100}
              path={getSvgIconPathByType('amberSearch')}
            />
            <Empty
              customMessage={t(
                'projects:addIn.extensions.amberSearch.noExtension'
              )}
            />
          </div>
        )}
      </div>
    </Flex.Column>
  );
};

export default AmberSearchPage;
